import React from 'react';

import HomeHeroCarousel from '../../components/Redesign/HomeHeroCarousel';
import Intro from '../../components/Redesign/Intro';
import Placements from '../../components/Redesign/Placements';
import GuestJourney from '../../components/Redesign/GuestJourney';
import TravelerCarousel from '../../components/Redesign/TravelerCarousel';
import PartnerStories from '../../components/Redesign/PartnerStories';
import BonvoyStats from '../../components/Redesign/BonvoyStats';
import BonvoyStatsIntro from '../../components/Redesign/BonvoyStatsIntro';
import TalkToTeam from '../../components/Redesign/TalkToTeam';
import PlatformIntro from '../../components/Redesign/PlatformIntro';
import Brands from '../../components/Redesign/Brands';
import Partners from '../../components/Redesign/Partners';
import { useAdobeDataLayer, PageNames } from '../../hooks/useAdobeDataLayer';

import './Home.css';

const Home = () => {
  const { sendPageView } = useAdobeDataLayer();

  React.useEffect(() => {
    sendPageView(PageNames.Home);
  }, [sendPageView]);

  return (
    <div className='home-page'>
      <HomeHeroCarousel />
      <div className='intro-desktop-only'>
        <Intro />
      </div>
      <BonvoyStatsIntro />
      <TravelerCarousel />
      <BonvoyStats />
      <Brands />
      <GuestJourney />
      <PlatformIntro />
      <Placements />
      <PartnerStories />
      <Partners />
      <TalkToTeam />
    </div>
  );
};

export default Home;
